import { render } from "./Column.vue?vue&type=template&id=4b896350&scoped=true&ts=true"
import script from "./Column.vue?vue&type=script&lang=ts"
export * from "./Column.vue?vue&type=script&lang=ts"

import "./Column.vue?vue&type=style&index=0&id=4b896350&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b896350"]])

export default __exports__